module.exports = __webpack_public_path__ + "img/volume_mute.65bfa93e.svg";